import { AnyAction } from 'redux';
import * as types from './types';

const INITIAL_STATE = {
    data: false,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INITIAL_STATE, action: AnyAction) => {
    switch (action.type) {
        case types.SHOW_LOADER:
            return {
                data: true,
            };
        case types.HIDE_LOADER:
            return {
                data: false,
            };
        default:
            return state;
    }
};
